import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import Webinars from 'features/webinars';

const Page = () => (
	<MainLayout>
		<Webinars />
	</MainLayout>
);

export default Page;
